import { render, staticRenderFns } from "./ProductInstanceBarcodesList.component.vue?vue&type=template&id=050ac188&scoped=true&"
import script from "./ProductInstanceBarcodesList.component.vue?vue&type=script&lang=js&"
export * from "./ProductInstanceBarcodesList.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050ac188",
  null
  
)

export default component.exports